// initial state
const state = {
// serverUrl: 'http://192.168.10.123:8088'
 serverUrl: 'http://www.yaozhicai.cn:8088'
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js